module.exports = __webpack_public_path__ + "static/media/market.4fce6fad.svg";